/**
 * The window height to lay the game map out against: while a soft keyboard is
 * open (same width — not a rotation), keep the pre-keyboard height so the map
 * doesn't shrink when Android resizes the window for the keyboard.
 * RN-free for unit testing.
 */
export function stableWindowHeight(args: {
  width: number
  height: number
  keyboardUp: boolean
  /** Last window size observed with no keyboard open. */
  settled: { width: number; height: number }
}): number {
  const { width, height, keyboardUp, settled } = args
  if (keyboardUp && width === settled.width && height < settled.height) return settled.height
  return height
}
